import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-brand-title">
              <Link to="/" className="footer-brand-link" aria-label="Go to home">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo10.png`}
                  alt="PaisaWise logo"
                  className="footer-brand-logo"
                  width={36}
                  height={36}
                  decoding="async"
                />
                <span>PaisaWise</span>
              </Link>
            </h3>
            <p>Your source for insightful articles, investment insights,<br /> and thought-provoking content.</p>
            <ul>
              <li><Link to="/about" className="footer-about-link">About Us</Link></li>
              <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Learning</h4>
            <ul>
              <li className="footer-nav-group">
                <a href="/category/financial-planning">Financial Planning</a>
                <ul className="footer-sub-links">
                  <li><a href="/category/financial-planning#retirement">Retirement</a></li>
                  <li><a href="/category/financial-planning#loan">Loan</a></li>
                  <li><a href="/category/financial-planning#miscellaneous">Miscellaneous</a></li>
                </ul>
              </li>
              <li className="footer-nav-group">
                <a href="/category/investment-strategies">Investment Strategies</a>
                <ul className="footer-sub-links">
                  <li><a href="/category/investment-strategies#mutual-funds">Mutual Funds</a></li>
                  <li><a href="/category/investment-strategies#miscellaneous">Miscellaneous</a></li>
                </ul>
              </li>
              <li><a href="/category/tax-planning">Tax Planning</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect with us</h4>
            <ul>
            <li><a href="#linkedin">LinkedIn</a></li>
              <li><a href="#twitter">Twitter</a></li>
              <li><a href="#github">Instagram</a></li>
              <li><a href="#youtube">YouTube</a></li>
            </ul>
          </div>
          
          {/* <div className="footer-section">
            <h4>Newsletter</h4>
            <p>Stay updated with our latest posts</p>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="newsletter-input"
              />
              <button className="btn newsletter-btn">Subscribe</button>
            </div>
          </div> */}
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} PaisaWise. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
